import { faEye } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders an Eye icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/eye?f=classic&s=solid
 */
export const EyeIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faEye} {...props} />;
};
